const smoothScroll = (element) => {
  document.querySelector(element).scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
};

export default smoothScroll;
